<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar parar o Projeto</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-system-loader [loader]="isLoading"></app-system-loader>

    <form [formGroup]="form" (ngSubmit)="clonar()">
      <div class="form-group row m-b table-form">
        <div class="col-sm-12">
          <label class="col-sm-12 pb-1">Projeto</label>
          <ng-select id="pf_id" class="ng-select-alternative" [items]="listProjeto" bindLabel="label" bindValue="id" placeholder="Selecione o Projeto" formControlName="pf_id">
          </ng-select>
          <app-field-message [field]="fieldMessageRequired('pf_id')" [erros]="fieldErros('pf_id')"></app-field-message>
        </div>
      </div>

      <div class="form-group row m-b" *ngIf="paramsRouter">
        <div class="col-sm-12">
          <label class="col-sm-12 pb-1" for="param">Copiar Plano de Ação</label>
          <div class="switch">
            <div class="onoffswitch">
              <input type="checkbox" (change)="form.get('param').setValue(!form.get('param').value)" class="onoffswitch-checkbox" id="param">
              <label class="onoffswitch-label" for="param">
                <span class="onoffswitch-inner switchSimNao"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeModal()">Voltar</button>
          <button class="btn btn-primary" type="submit">Clonar</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>